"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageBundleT = exports.MessageBundle = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const data_feed_message_header_js_1 = require("../solarxr-protocol/data-feed/data-feed-message-header.js");
const pub_sub_header_js_1 = require("../solarxr-protocol/pub-sub/pub-sub-header.js");
const rpc_message_header_js_1 = require("../solarxr-protocol/rpc/rpc-message-header.js");
/**
 * MessageBundle contains all of the messages for the data feed system and the
 * rpc system that will be sent in one buffer.
 */
class MessageBundle {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsMessageBundle(bb, obj) {
        return (obj || new MessageBundle()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsMessageBundle(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new MessageBundle()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    dataFeedMsgs(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new data_feed_message_header_js_1.DataFeedMessageHeader()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    dataFeedMsgsLength() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    rpcMsgs(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? (obj || new rpc_message_header_js_1.RpcMessageHeader()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    rpcMsgsLength() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    pubSubMsgs(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? (obj || new pub_sub_header_js_1.PubSubHeader()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    pubSubMsgsLength() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    static startMessageBundle(builder) {
        builder.startObject(3);
    }
    static addDataFeedMsgs(builder, dataFeedMsgsOffset) {
        builder.addFieldOffset(0, dataFeedMsgsOffset, 0);
    }
    static createDataFeedMsgsVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startDataFeedMsgsVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static addRpcMsgs(builder, rpcMsgsOffset) {
        builder.addFieldOffset(1, rpcMsgsOffset, 0);
    }
    static createRpcMsgsVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startRpcMsgsVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static addPubSubMsgs(builder, pubSubMsgsOffset) {
        builder.addFieldOffset(2, pubSubMsgsOffset, 0);
    }
    static createPubSubMsgsVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startPubSubMsgsVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static endMessageBundle(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createMessageBundle(builder, dataFeedMsgsOffset, rpcMsgsOffset, pubSubMsgsOffset) {
        MessageBundle.startMessageBundle(builder);
        MessageBundle.addDataFeedMsgs(builder, dataFeedMsgsOffset);
        MessageBundle.addRpcMsgs(builder, rpcMsgsOffset);
        MessageBundle.addPubSubMsgs(builder, pubSubMsgsOffset);
        return MessageBundle.endMessageBundle(builder);
    }
    unpack() {
        return new MessageBundleT(this.bb.createObjList(this.dataFeedMsgs.bind(this), this.dataFeedMsgsLength()), this.bb.createObjList(this.rpcMsgs.bind(this), this.rpcMsgsLength()), this.bb.createObjList(this.pubSubMsgs.bind(this), this.pubSubMsgsLength()));
    }
    unpackTo(_o) {
        _o.dataFeedMsgs = this.bb.createObjList(this.dataFeedMsgs.bind(this), this.dataFeedMsgsLength());
        _o.rpcMsgs = this.bb.createObjList(this.rpcMsgs.bind(this), this.rpcMsgsLength());
        _o.pubSubMsgs = this.bb.createObjList(this.pubSubMsgs.bind(this), this.pubSubMsgsLength());
    }
}
exports.MessageBundle = MessageBundle;
class MessageBundleT {
    constructor(dataFeedMsgs = [], rpcMsgs = [], pubSubMsgs = []) {
        this.dataFeedMsgs = dataFeedMsgs;
        this.rpcMsgs = rpcMsgs;
        this.pubSubMsgs = pubSubMsgs;
    }
    pack(builder) {
        const dataFeedMsgs = MessageBundle.createDataFeedMsgsVector(builder, builder.createObjectOffsetList(this.dataFeedMsgs));
        const rpcMsgs = MessageBundle.createRpcMsgsVector(builder, builder.createObjectOffsetList(this.rpcMsgs));
        const pubSubMsgs = MessageBundle.createPubSubMsgsVector(builder, builder.createObjectOffsetList(this.pubSubMsgs));
        return MessageBundle.createMessageBundle(builder, dataFeedMsgs, rpcMsgs, pubSubMsgs);
    }
}
exports.MessageBundleT = MessageBundleT;
